export default "__VITE_ASSET__DT4Dtfw9__"